import { lazy } from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { FeatureRouteGuard } from "@/components/common/FeatureRouteGuard";

const DocumentExtractionPage = lazy(() => import("@/pages/documents/DocumentExtractionPage"));

export function DocumentRoutes() {
  return (
    <>
      <Route 
        path="/documents/extraction" 
        element={
          <ProtectedRoute>
            <FeatureRouteGuard feature="document_extraction">
              <DocumentExtractionPage />
            </FeatureRouteGuard>
          </ProtectedRoute>
        } 
      />
    </>
  );
}
